var pardot_domains = [
{
  "name" : "geonet.esri.com",
  "piCId" : "3982",
  "piAId" : "83202"
},
{
  "name" : "supportdev.esri.com",
  "piCId" : "2258",
  "piAId" : "86732"
},
{
  "name" : "accounts-dev.esri.com",
  "piCId" : "2258",
  "piAId" : "86732"
},
{
  "name" : "video.esri.com",
  "piCId" : "3996",
  "piAId" : "83202"
},
{
  "name" : "www.gisday.com",
  "piCId" : "3992",
  "piAId" : "83202"
},
{
  "name" : "www.urbanobservatory.org",
  "piCId" : "3990",
  "piAId" : "83202"
},
{
  "name" : "store.esri.com",
  "piCId" : "3988",
  "piAId" : "83202"
},
{
  "name" : "cmsdev.esri.com",
  "piCId" : "3026",
  "piAId" : "86702"
},
{
  "name" : "cmsqa.esri.com",
  "piCId" : "3666",
  "piAId" : "86722"
},
{
  "name" : "arcgis.com",
  "piCId" : "1602",
  "piAId" : "83202"
},
{
  "name" : "devext.arcgis.com",
  "piCId" : "1602",
  "piAId" : "86732"
},
{
  "name" : "qaext.arcgis.com",
  "piCId" : "1602",
  "piAId" : "86702"
},
{
  "name" : "www.esri.com",
  "piCId" : "1602",
  "piAId" : "83202"
},
{
  "name" : "e380.esri.com",
  "piCId" : "3996",
  "piAId" : "83202"
},
{
  "name" : "edcommunity.esri.com",
  "piCId" : "4000",
  "piAId" : "83202"
},
{
  "name" : "accounts.esri.com",
  "piCId" : "3980",
  "piAId" : "83202"
},
{
  "name" : "training.esri.com",
  "piCId" : "3978",
  "piAId" : "83202"
},
{
  "name" : "support.esri.com",
  "piCId" : "3976",
  "piAId" : "83202"
},
{
  "name" : "partners.esri.com",
  "piCId" : "3986",
  "piAId" : "83202"
},
{
  "name" : "my.esri.com",
  "piCId" : "na",
  "piAId" : "86702"
},
{
  "name" : "blogs.esri.com",
  "piCId" : "na",
  "piAId" : "86702"
},
{
  "name" : "esripress.esri.com",
  "piCId" : "na",
  "piAId" : "86702"
},
{
  "name" : "events2.esri.com",
  "piCId" : "3984",
  "piAId" : "83202"
},
{
  "name" : "cmsauth.esri.com",
  "piCId" : "4012",
  "piAId" : "83202"
},
{
  "name" : "webapps-cdn-stg.esri.com",
  "piCId" : "3666",
  "piAId" : "83202"
},
{
  "name" : "videostg.esri.com",
  "piCId" : "3996",
  "piAId" : "86722"
},
{
  "name" : "go.esri.com",
  "piCId" : "1602",
  "piAId" : "83202"
},
{
  "name" : "registration.esri.com",
  "piCId" : "1602",
  "piAId" : "83202"
}];
